import { Label } from "../../label";
import { Input } from "../../input";
import { DatePicker } from "../../DateTimePicker";

export interface InformationContentProps {
  contact?: {
    id?: string;
    fname?: string;
    lname?: string;
    email?: string;
    phone?: string;
    dateOfBirth?: string | number;
    createdAt: string | number;
    updatedAt: string | number;
  };
}

export function InformationContent({ contact }: InformationContentProps) {
  const formatDate = (date: string | number | undefined) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString();
  };

  const formatDateTime = (date: string | number) => {
    return new Date(date).toLocaleString();
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="fname">First Name</Label>
        <Input id="fname" value={contact?.fname || ""} />
      </div>
      <div className="space-y-2">
        <Label htmlFor="lname">Last Name</Label>
        <Input id="lname" value={contact?.lname || ""} />
      </div>
      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input id="email" value={contact?.email || ""} type="email" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="phone">Phone</Label>
        <Input id="phone" value={contact?.phone || ""} />
      </div>
      <div className="space-y-2">
        <Label htmlFor="dob">Date of Birth</Label>
        <DatePicker
          id="dob"
          value={contact?.dateOfBirth ? new Date(contact.dateOfBirth) : undefined}
          placeholder={contact?.dateOfBirth ? formatDate(contact.dateOfBirth) : "Not provided"}
          className="space-y-0"
          label=""
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="dateAdded">Date Added</Label>
        {/* TODO: fix the createdAt type. For some reason `ClientModelForName['endusers'].createdAt` is a Date when it's a string in reality */}
        <Input id="dateAdded" value={formatDateTime((contact?.createdAt as string | undefined) || "")} disabled />
      </div>
      <div className="space-y-2">
        <Label htmlFor="dateUpdated">Date Updated</Label>
        {/* TODO: fix the createdAt type. For some reason `ClientModelForName['endusers'].createdAt` is a Date when it's a string in reality */}
        <Input id="dateUpdated" value={formatDateTime((contact?.createdAt as string | undefined) || "")} disabled />
      </div>
      <div className="space-y-2">
        <Label htmlFor="primaryInsurance">Primary Insurance</Label>
        <Input id="primaryInsurance" defaultValue="Blue Cross Blue Shield" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="secondaryInsurance">Secondary Insurance</Label>
        <Input id="secondaryInsurance" defaultValue="Medicare Part B" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="address">Address</Label>
        <Input id="address" defaultValue="123 Main St, Springfield, IL 62701" />
      </div>
    </div>
  );
}
